<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
        <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
            <span style="float:left">Cases Summary</span>
        </h6>
    </div>
    <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
        <app-support-case-summary></app-support-case-summary>
    </div>
</div>
<div *ngIf="!accessdenied" class="row" style="margin-top: 15px;">
    <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
        <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
            <span style="float:left">All Cases</span>
        </h6>
    </div>
    <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
        <div class="col-md-12 col-sm-12 ">
            <div *ngIf="!isLoading" class="row" style="margin-bottom:10px">
                <div class="col-xl-3 col-md-6 col-xs-6 col-sm-6" *ngFor="let status of casesStatus " style="margin-bottom: 10px;">
                    <a (click)="applyStatusFilter(status.code)" [ngStyle]="{'background-color': status.isActive ? status.active_background_color : status.inactive_background_color, 'color': status.isActive ? status.active_color : status.inactive_color, 'border-color': status.inactive_color }" style="width: 100%; font-size: 13px; height: 35px; margin-right: 20px; font-weight: inherit; color: #00A6B6;" class="btn btn-default">
                        {{status.name}}
                    </a>
                </div>

            </div>
            <div class="row">
                <div *ngIf="isLoading" class="col-xl-12" style="margin-bottom:20px">
                    <div style="text-align: right" class="clearfix">
                        <div class="spinner-border float-right" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isLoading" class="form-group col-md-12 col-sm-12 col-xs-12" style="margin-bottom:20px">
                    <div class="form-floating">
                        <input type="text" class="form-control" id="floatingInputValueSubject" (keyup)="applyFilter($event)">
                        <label for="floatingInputValueSubject">Search for support case</label>
                    </div>
                </div>

            </div>

            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort style="width:100%">

                    <!-- ID Column -->
                    <ng-container matColumnDef="case">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Case </th>
                        <td mat-cell *matCellDef="let row">

                            <div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 10px; padding-top: 10px;">
                                <small>
                                    <b>{{row.caseNumber}}</b> |
                                    <span *ngIf="row.status == 'Escalated'" style="background-color: red; padding: 3px; border-radius: 5px; color: white;">{{row.status}}</span>
                                    <span *ngIf="row.status == 'New'" style="background-color: green; padding: 3px; border-radius: 5px; color: white;">{{row.status}}</span>
                                    <span *ngIf="row.status == 'Open'" style="background-color: green; padding: 3px; border-radius: 5px; color: white;">{{row.status}}</span>
                                    <span *ngIf="row.status == 'On Hold'" style="background-color: orange; padding: 3px; border-radius: 5px; color: white;">{{row.status}}</span>
                                    <span *ngIf="row.status != 'Escalated' && row.status != 'New' && row.status != 'Open' && row.status != 'On Hold'" style="background-color: grey; padding: 3px; border-radius: 5px; color: white;">{{row.status}}</span>
                                </small>
                            </div>
                            <div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom:10px">
                                {{splitText(row.subject)}}
                            </div>
                        </td>
                    </ng-container>

                    <!-- Progress Column -->
                    <!--<ng-container matColumnDef="analyst">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Analyst </th>
                <td mat-cell *matCellDef="let row"> {{row.analyst}} </td>
            </ng-container>-->
                    <!-- Name Column -->
                    <ng-container matColumnDef="owner">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Submitted by </th>
                        <td mat-cell *matCellDef="let row"> {{row.owner}} </td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Las modified date </th>
                        <td mat-cell *matCellDef="let row" style="opacity:.5"> {{row.date | date:'medium'}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr class="table_row" mat-row (click)="clickedRows(row)" *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="3">{{loadingMessage}}</td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[25, 50, 100]" aria-label="Select page of users"></mat-paginator>
            </div>

        </div>

    </div>

</div>